import { Component, inject, Input } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { TranslationService } from '@app/common/translation.service';
import { Language } from '@shared/interfaces/languages';

@Component({
    selector: 'sas-language-selector',
    standalone: true,
    imports: [NgbDropdownModule, TranslateModule],
    templateUrl: './sas-language-selector.component.html',
    styleUrl: './sas-language-selector.component.scss'
})
export class SasLanguageSelectorComponent {
    private translate = inject(TranslateService);
    private translationService = inject(TranslationService);

    @Input() sasLangData?: Array<Language> = [];
    @Input() sasTranslationModule?: string = '';

    lang: string = this.translate.currentLang;
    languageSelected?: Language;

    ngOnInit() {
        this.changeLanguage(this.lang, true);
    }

    changeLanguage(langSelected: string, init: boolean = false) {
        this.lang = langSelected;

        if (!init) {
            this.translationService.changeLang(this.lang);
        }
        this.setHtmlLang(this.lang);

        if (this.sasLangData !== null && this.sasLangData!.length > 1) {
            this.languageSelected = this.sasLangData?.find(lang => lang.value === langSelected);
        }
    }

    setHtmlLang(lang: string, init: boolean = false) {
        const html = document.querySelector('html');
        const previousLang = html?.getAttribute('lang');

        if (previousLang !== lang || init) {
            html?.setAttribute('lang', lang);
        }
    }
}
